import { render, staticRenderFns } from "./RangeChoice.vue?vue&type=template&id=97030ed8&"
import script from "./RangeChoice.vue?vue&type=script&lang=js&"
export * from "./RangeChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports